import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-screen flex overflow-hidden bg-wrh-blue-background" }
const _hoisted_2 = { class: "flex flex-col w-0 flex-1 overflow-y-auto" }
const _hoisted_3 = { class: "flex-1 relative focus:outline-none" }
const _hoisted_4 = { class: "flex flex-col w-full h-full" }
const _hoisted_5 = { class: "max-w-8xl mx-auto px-4 sm:px-6 md:px-4 lg:px-10 flex-grow w-full" }

import { ref } from 'vue';
import { useRoute } from 'vue-router';
import Header from '../components/Header.vue';
import Sidebar from '../components/Sidebar.vue';
import Footer from '../components/Footer.vue';
import { SidebarIconName } from '../constants/enums';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const homeId = route.params.homeId as string;
// const error = ref();
// const homes = useHomes()

// debug
// watch(error, val => console.log('error', val))

const navigation = [
  {
    name: 'Dashboard',
    href: `/homes/${homeId}`,
    icon: SidebarIconName.dashboard,
  },
  {
    name: 'Timeline',
    href: `/homes/${homeId}/timeline`,
    icon: SidebarIconName.timeline,
  },
  {
    name: 'My Messages',
    href: `/homes/${homeId}/messages`,
    icon: SidebarIconName.messages,
  },
  {
    name: 'My Photos',
    href: `/homes/${homeId}/photos`,
    icon: SidebarIconName.photos,
  },
  {
    name: 'My Documents',
    href: `/homes/${homeId}/documents`,
    icon: SidebarIconName.documents,
  },
  {
    name: 'Warranty',
    href: `/homes/${homeId}/warranty`,
    icon: SidebarIconName.warranty,
  },
];

const sidebarOpen = ref(false);

// TODO: how to display errors?
// onErrorCaptured((err) => {
//   error.value = err
// })

// homes.activate(homeId)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Sidebar, {
      sidebarOpen: sidebarOpen.value,
      navigation: navigation,
      onCloseSidebar: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = false))
    }, null, 8, ["sidebarOpen"]),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(Header, {
        navigation: navigation,
        onOpenSidebar: _cache[1] || (_cache[1] = ($event: any) => (sidebarOpen.value = true))
      }),
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_view, null, {
              default: _withCtx(({ Component }) => [
                Component
                  ? (_openBlock(), _createBlock(_Transition, {
                      key: 0,
                      mode: "out-in"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(Footer)
    ])
  ]))
}
}

})